export default "__VITE_ASSET__D$ZzqpRB__"